import React from 'react';
import { Outlet } from 'react-router-dom';

const SponsoredAdvertsRouter: React.FC = () => {
  return <Outlet />;
};

export default SponsoredAdvertsRouter;
